export var makePropList = function makePropList(list) {
  var result = {};
  list.forEach(function (property) {
    result[property] = true;
  });
  return result;
};